import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { fetchprograms } from '../../redux/actions/programactions'
import TVSchedule from '../../components/TVSchedule/TVSchedule'
import './schedule.css'

const Schedule = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchprograms())
  }, [dispatch])

  return (
    <div className="schedule-page">
      <Container>
        <TVSchedule/>
      </Container>
    </div>
  )
}

export default Schedule
